import { inject } from "fw";
import { createFrom } from "fw-model";

import { Manager } from "network/manager";

import { ContactsAppMetrics, ContactsSystemMetrics } from "models/contacts-metrics";
import { SearchResult } from "models/search-result";
import { TaskRequest } from "models/task-request";
import { WebHookHistory } from "models/web-hook-history";

export class WebHookHistorySearchResult extends SearchResult<WebHookHistory> {}

@inject
export class ContactsRepository {
    constructor(private s: Manager) {}

    public async getContacts(
        organizationId: string = null,
        q: string = null,
        f: string = null,
        sort: string = null,
        page = 1,
        limit = 10,
        contactType: string = null
    ): Promise<any> {
        const res = await (contactType?.length > 0
            ? this.s.get(`contacts/${contactType}`, { organizationId, q, f, sort, page, limit })
            : this.s.get("contacts", { organizationId, q, f, sort, page, limit }));
        return res?.body;
    }

    public async appMetrics(organizationId: string = null) {
        const response = organizationId
            ? await this.s.get<ContactsAppMetrics>(`contacts/organizations/${organizationId}/metrics/app`)
            : await this.s.get<ContactsAppMetrics>("contacts/metrics/app");

        return createFrom(ContactsAppMetrics, response.body);
    }

    public async systemMetrics() {
        const response = await this.s.get<TaskRequest[]>("contacts/metrics/system");
        return createFrom(ContactsSystemMetrics, response.body);
    }

    public async getWebHookHistoryById(id: string = null) {
        const response = await this.s.get<WebHookHistory>(`contacts/webhook-history/${id}`);
        return createFrom(WebHookHistory, response.body);
    }

    public async getWebHookHistories(
        organizationId: string = null,
        dataSourceInstanceId: string,
        start: string | Date = null,
        end: string | Date = null,
        sort: string = null,
        q: string = null,
        f: string = null,
        page = 1,
        limit = 10,
        fields: string = null,
        aggs: string = null
    ) {
        const params = {
            page,
            limit: limit || 10,
            ...(dataSourceInstanceId && { dataSourceInstanceId }),
            ...(start && { start }),
            ...(end && { end }),
            ...(sort && { sort }),
            ...(q && { q }),
            ...(f && { f }),
            ...(fields && { fields }),
            ...(aggs && { aggs })
        };
        const response = organizationId
            ? await this.s.get<WebHookHistorySearchResult>(`contacts/organizations/${organizationId}/webhook-history`, params)
            : await this.s.get<WebHookHistorySearchResult>("contacts/webhook-history", params);
        if (!response.body?.Total && response.body?.Results?.length > 0) response.body.Total = parseInt(response.headers["x-manager-total"]);
        return createFrom(WebHookHistorySearchResult, response.body);
    }
}
